module.exports = __webpack_public_path__ + "static/media/plus.fd156d03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 548
// module chunks = 0